"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrecheckCta = PrecheckCta;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function PrecheckCta({
  addToCartUrl,
  id,
  itemTrackingCode,
  trackingCustomProperties,
  width,
  isServerSideRender,
  ...nsMerchButtonProps
}) {
  const [shopperId, setShopperId] = (0, _react.useState)(null);
  let atcUrl = addToCartUrl;
  const updateCartUrl = cartTotal => {
    if (!isServerSideRender && typeof URL !== 'undefined') {
      const updatedUrl = new URL(addToCartUrl);
      updatedUrl.searchParams.set('cartItem', cartTotal);
      atcUrl = updatedUrl.href;
    }
  };
  const fetchCartData = async () => {
    try {
      if (shopperId) {
        const envStr = (0, _patternLibraryUtils.getDefaultEnv)();
        const env = envStr === 'prod' ? '' : `${envStr}-`;

        // Create an AbortController for GUI Failures
        const controller = new AbortController();
        const signal = controller.signal;
        // Set a timeout of 500ms
        const timeoutId = setTimeout(() => controller.abort(), 500);

        // eslint-disable-next-line max-len
        await fetch(`https://gui.${env}godaddy.com/pcjson/salesheader?plId=1&shopperId=${shopperId}&sid=${shopperId}`, {
          credentials: 'include',
          signal: signal
        }).then(res => res.json()).then(res => {
          updateCartUrl(res.carttotal);
        }).finally(() => {
          // Clear the timeout to prevent unnecessary aborts
          clearTimeout(timeoutId);
        });
      } else {
        updateCartUrl('0');
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        // Handle GUI Timeout Error
        // When GUI calls fail, we avoid adding the queryParam on the page
        // eslint-disable-next-line no-console
        console.error('GUI Fetch request timed out after 500ms', error);
      } else {
        // eslint-disable-next-line no-console
        console.error('Error fetching cart data from GUI', error);
      }
    }
  };
  const handleButtonClick = async event => {
    event.preventDefault();
    await fetchCartData();
    event.target.form.action = atcUrl;
    event.target.form.submit();
  };
  (0, _react.useEffect)(() => {
    const idpCookieValue = (0, _patternLibraryUtils.getCookieValue)('info_idp') || (0, _patternLibraryUtils.getCookieValue)('info_cust_idp');
    if (idpCookieValue) {
      const cookieObj = window.decodeURIComponent && window.JSON && window.JSON.parse ? window.JSON.parse(window.decodeURIComponent(idpCookieValue)) : null;
      const sid = cookieObj.del ? cookieObj[cookieObj.auth].info_shopperId : cookieObj.info_shopperId;
      setShopperId(sid);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
    onClick: event => handleButtonClick(event),
    id: id,
    isPromo: false,
    "data-cy": "precheck-button",
    "data-itc": itemTrackingCode,
    width: width,
    type: "submit",
    addToCartUrl: addToCartUrl,
    isServerSideRender: isServerSideRender,
    trackingCustomProperties: trackingCustomProperties
  }, nsMerchButtonProps));
}
PrecheckCta.propTypes = {
  addToCartUrl: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  itemTrackingCode: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object,
  isServerSideRender: _propTypes.default.bool,
  width: _propTypes.default.string
};